import Swiper, {Autoplay, Navigation, Thumbs} from "swiper";

export default (el) => {
  new Swiper(".js-p-home-sliding-mobile", {
    modules: [Thumbs, Navigation, Autoplay],
    spaceBetween: 10,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".js-sliding-mobile-next",
      prevEl: ".js-sliding-mobile-prev",
    },
  });
}
